export const githubRepository = "https://github.com/develinu/design-ui-challenge"

export const menus = [
  // {
  //   to: '/',
  //   name: 'Search'
  // },
  // {
  //   to: '/recommend',
  //   name: 'Recommend'
  // }
]